module.exports = __webpack_public_path__ + "static/media/wellnessexpertimg.5750f452.svg";